/**
 * @overview 菜单列表
 * @author 3173
 * @date 2019-12
 */

import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { Menu } from 'antd';
let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let { WizNotice, WizBrowserExport,WizModal } = component_tool;
let { checkStrLength } = utils_tool;
class KnowledgeBaseList extends WizContainer {

  componentName = 'KnowledgeBaseList';

  constructor(props) {
    super(props);
    this.state = {
      // record:{},
      // flagList:[1,2],
      // categoryOperateType:1,
      // labelOperateType:1,
      // oldCategoryIdList:[],
      // newCategoryIdList:[],
      // oldLabelIdList:[],
      // newLabelIdList:[],
    }
  }

  _componentDidMount() {
    const { history } = this.props;
    this.doActions([
      {
        path: 'menu/getMenus',
        payload: {
          key: 'menu_getMenusForTpye',
          apiParams: {
            type: 0,
            neIds: null
          }
        },
        requireLoading: true,
      },
    ])

  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 10
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标题',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
          font:{ }
        },
      },
      {
        headerName: '作者类型',
        field: 'authorTypeStr',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '作者',
        field: 'author',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '作者介绍',
        field: 'authorIntro',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '所属组织',
        field: 'belongOrg',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '品牌',
        field: 'brandName',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '功能块',
        field: 'module',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '知识类型',
        field: 'proKnowledgeTypeTitle',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center',wrapText:true },
        },
      },
      {
        headerName: '分类',
        field: 'categoryStr',
        width: 50,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '标签',
        field: 'labelStr',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '生效时间',
        field: 'effectiveTime',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '失效时间',
        field: 'failureTime',
        width: 30,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center',wrapText:true  },
        },
      },
      {
        headerName: '状态',
        field: 'stateStr',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center',wrapText:true  },
        },
      },
      {
        headerName: '发布终端',
        field: 'releasePlatformStr',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '添加水印',
        field: 'watermarkStr',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '版本',
        field: 'version',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '变更人',
        field: 'updateFullName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data && data.forEach(d => {
        let module = d['module']
        let dict =[
          { code: 0, codeName: "销售" },
          { code: 1, codeName: "售后服务" },
          { code: 2, codeName: "售后技术" },
          { code: 3, codeName: "诚新二手车" },
          { code: 4, codeName: "校企合作" },
          { code: 5, codeName: "集团销售" },
          { code: 9, codeName: "跨业务块" },
        ]
        let moduleName = "";
        dict.forEach(e=>{
          if(e.code==module){
            moduleName = e.codeName;
          }
        })

        let _d = { ...d ,module:moduleName}
        let authData = d['authInfo']
        let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['scope'] = target
        _data.push(_d)
      })
      WizBrowserExport({
        title: '知识库信息',
        sheetName: '知识库信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '知识库信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _dynaBts(data){
    let bts = [];
    data && data.data && data.data.forEach(element=>{
      let menuItem = <Menu.Item key={element.id} onClick={()=>{this.jumpPage('replace','/proKnowledge/knowledgeBaseList/knowledgeBaseDetailAdd',{knowledgeTypeId:element.id,version:"V1.0"})}}>{element.title} </Menu.Item>
      bts.push(menuItem);
    })
    return bts;
  }

  // _handleBatchUpdateCMD(nextProps, nextState, key) {
  //   let o = nextProps[key]
  //   if (o['success']) {
  //     if(o.data.flag===0){
  //       let { record,flagList, categoryOperateType, labelOperateType,oldCategoryIdList,newCategoryIdList,oldLabelIdList,newLabelIdList } = this.state
  //       let idList = [];
  //       record.forEach(element => {
  //         idList.push(element.id);
  //       });
  //       let apiParams = {
  //         flagList, categoryOperateType, labelOperateType,oldCategoryIdList,newCategoryIdList,oldLabelIdList,newLabelIdList,keepDoItFlag:1,idList
  //       }
  //       WizModal.confirm({
  //         title: "注意",
  //         content : o.data.msg,
  //         onOk: () => {
  //           this.doAction({
  //             path: 'proKnowledge/batchUpdate',
  //             payload: {
  //               key: 'proKnowledge@batchUpdate',
  //               apiParams: {
  //                 ...apiParams
  //               }
  //             }
  //           })
  //         },
  //         onCancel() {
  //         },
  //       });
  //     }else{
  //       this.changeModal(false, true, true)
  //       wizNotice.success(o['msg'])
  //     }
  //     return true;
  //   } else {
  //     wizNotice.error(o['msg'])
  //     return false;
  //   }
  // }
  
  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this._dynaBts(this.props.proKnowledgeTypes),this),
      apiDataFormat: {
        treeData: this._handleTreeData,
        export: this._handleFile,
       // batchUpdate: this._handleBatchUpdateCMD.bind(this),
        updateState: this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { menu, elements,proKnowledgeType } = state;
  const folderMenus = modelUtils.getModelEntity(menu, "menu_getMenusForTpye");
  const proKnowledgeTypes = modelUtils.getModelEntity(proKnowledgeType, "proKnowledgeType@export");
  const load = modelUtils.getLoadingState(state, ['elements', 'menu']);
  return {
    folderMenus: folderMenus.data,
    proKnowledgeTypes: proKnowledgeTypes,
    ...load
  }
};

export default connect(mapStateToProps)(KnowledgeBaseList);
